import { render } from "./RegPage.vue?vue&type=template&id=7dd50426&scoped=true"
import script from "./RegPage.vue?vue&type=script&lang=js"
export * from "./RegPage.vue?vue&type=script&lang=js"

import "./RegPage.vue?vue&type=style&index=0&id=7dd50426&scoped=true&lang=css"

import exportComponent from "D:\\Development\\javascript\\accounts-butago-vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7dd50426"]])

export default __exports__